var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    viewBox: "0 0 17 17",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.875 12.75-.7084.775c-.3757.4108-.8852.6417-1.4165.6417s-1.0408-.2309-1.4165-.6417c-.3762-.4101-.8857-.6404-1.41681-.6404-.5311 0-1.04057.2303-1.41681.6404m-6.37498.6417h1.18613c.34651 0 .51976 0 .6828-.0392.14455-.0347.28274-.0919.40949-.1696.14297-.0876.26548-.2101.51049-.4551l8.89859-8.89864c.5868-.5868.5868-1.53819 0-2.125-.5868-.5868-1.5382-.5868-2.125 0l-8.89861 8.89864c-.24501.245-.36752.3675-.45513.5105-.07767.1267-.13491.2649-.16962.4095-.03914.163-.03914.3362-.03914.6827z",
    stroke: "#ec068d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9e24db3f209eb57bb35d677966723818.svg";
export { ForwardRef as ReactComponent };